<template>
    <div class="flex w-full">
        <WikiContainer />
    </div>
</template>

<script>
    import WikiContainer from '@modules/wiki/WikiContainer.vue';

    export default {
        name: 'WikiPage',
        beforeRouteLeave(to, from, next) {
            next();
        },
        components: {
            WikiContainer,
        },
    };
</script>
